import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { AssignTargetStyle } from "./AssignTarget.Style";
import AssignTargetCardComponent from "./AssignTargetCard.component";
import { useAppContext } from "../../../../context/App.context";
import { useAuth } from "../../../../context/Auth.context";
import { useQuery, useSubscription } from "@apollo/client";
import { GET_CALL_COUNT } from "../../../../graphql/query/query";
import InformationDialog from "../../../base/dialog-body/Information.dialog";
import moment from "moment";
import { TYPE, firstOfMonth, today } from "../../../../utils/Utils";
import { Box, CircularProgress } from "@mui/material";
import { ON_EMPLOYEE_UPDATE } from "../../../../graphql/subscription/subscription";
import { useLayoutEffect } from "react";
import ManageUsersTable from "../../../../utils/ManageusersTable";

const AssignTarget = ({ dialog }) => {
  const app = useAppContext();
  const auth = useAuth();
  const { data, refetch } = useQuery(GET_CALL_COUNT, {
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    variables: {
      callInput: {
        d_startDate: app.fetchData.d_startDate || firstOfMonth,
        d_endDate: app.fetchData.d_endDate || today,
        dealership_id: auth?.user?.dealership_id,
        timezone: new Date().getTimezoneOffset(),
        isAdmin: false,
      },
    },
  });
  const { data: onEmployeeUpdate } = useSubscription(ON_EMPLOYEE_UPDATE, {
    variables: {
      dealership_id: auth?.user?.dealership_id,
    },
  });

  const TableDataHandler = (response) => {
    let newData = response.employee.filter(
      (person) => person.employee_user_id !== auth.user.user_id
    );
    let getActivateUser = newData.filter((person) => person.is_active);
    let managers = newData.filter((person) => person.role === "manager");
    let employees = newData.filter((person) => person.role === "employee");
    let firstData = response.employee.filter(
      (person) => person.employee_user_id === auth.user.user_id
    );
    app.setTarget([]);
    app.setTarget([...employees, ...firstData, ...managers]);
  };

  const getWorkFlowDetails = auth?.user?.associateDetails?.filter((data) => {
    return data?.dealership_id === auth?.user?.dealership_id;
  });

  useLayoutEffect(() => {
    if (data) {
      if (data?.getEmployeeTarget?.errors) {
        dialog({
          open: true,
          bodyType: TYPE.DEFAULT,
          body: (
            <InformationDialog
              text={data.getEmployeeTarget.errors[0].message}
            />
          ),
        });
      } else {
        TableDataHandler(data?.getEmployeeTarget);
      }
    }
  }, [data]);

  useLayoutEffect(() => {
    if (onEmployeeUpdate) {
      if (onEmployeeUpdate?.onEmployeeUpdate?.errors) {
        dialog({
          open: true,
          bodyType: TYPE.DEFAULT,
          body: (
            <InformationDialog
              text={onEmployeeUpdate.onEmployeeUpdate.errors[0].message}
            />
          ),
        });
      } else {
        TableDataHandler(onEmployeeUpdate?.onEmployeeUpdate?.employee_details);
      }
    }
  }, [onEmployeeUpdate]);

  const breadcrumb = {
    title: "Manage User",
    links: [
      { path: "/", name: "Home" },
      { path: null, name: "Manage User" },
    ],
  };

  const input = {
    dealership: getWorkFlowDetails[0],
    employees: app?.target,
    refetch: refetch,
    breadcrumb: breadcrumb,
    isAdminModule: false,
  };
  return (
    <ManageUsersTable input={input} />
    // <Paper sx={AssignTargetStyle.paper}>
    //   <Table stickyHeader>
    //     <TableHead sx={AssignTargetStyle.tableHead}>
    //       <TableRow sx={AssignTargetStyle.tableRow}>
    //         <TableCell
    //           sx={{
    //             ...AssignTargetStyle.tableCell,
    //             background: "#f4f6f8",
    //             fontWeight: "bold",
    //           }}
    //           width={"4%"}
    //         ></TableCell>
    //         <TableCell
    //           sx={{
    //             ...AssignTargetStyle.tableCell,
    //             background: "#f4f6f8",
    //             fontWeight: "bold",
    //             textAlign: "left",
    //           }}
    //           width={"18%"}
    //         >
    //           Full Name
    //         </TableCell>
    //         <TableCell
    //           sx={{
    //             ...AssignTargetStyle.tableCell,
    //             background: "#f4f6f8",
    //             fontWeight: "bold",
    //           }}
    //           width={"18%"}
    //         >
    //           Email
    //         </TableCell>
    //         <TableCell
    //           sx={{
    //             ...AssignTargetStyle.tableCell,
    //             background: "#f4f6f8",
    //             fontWeight: "bold",
    //           }}
    //           width={"18%"}
    //         >
    //           Mobile Number
    //         </TableCell>
    //         <TableCell
    //           sx={{
    //             ...AssignTargetStyle.tableCell,
    //             background: "#f4f6f8",
    //             fontWeight: "bold",
    //           }}
    //           width={"18%"}
    //         >
    //           Previous Target
    //         </TableCell>
    //         <TableCell
    //           sx={{
    //             ...AssignTargetStyle.tableCell,
    //             background: "#f4f6f8",
    //             fontWeight: "bold",
    //           }}
    //           width={"8%"}
    //         >
    //           Completed Verifications
    //         </TableCell>
    //         <TableCell
    //           sx={{
    //             ...AssignTargetStyle.tableCell,
    //             background: "#f4f6f8",
    //             fontWeight: "bold",
    //           }}
    //           width={"18%"}
    //         >
    //           Current Target
    //         </TableCell>
    //         {console.log("workflow", getWorkFlowDetails[0]?.crm_user_status)}
    //         {getWorkFlowDetails[0]?.crm_user_status ? (
    //           <TableCell
    //             sx={{
    //               ...AssignTargetStyle.tableCell,
    //               background: "#f4f6f8",
    //               fontWeight: "bold",
    //             }}
    //             width={"18%"}
    //           >
    //             URL
    //           </TableCell>
    //         ) : null}

    //         <TableCell
    //           sx={AssignTargetStyle.tableCell}
    //           width={"8%"}
    //         ></TableCell>
    //       </TableRow>
    //     </TableHead>

    //     <TableBody>
    //       {app?.target.length > 0 ? (
    //         app.target.map((row, index) => (
    //           <AssignTargetCardComponent key={index} row={row} />
    //         ))
    //       ) : (
    //         <TableRow>
    //           <TableCell sx={{ border: "none" }} colSpan={7}>
    //             <Box
    //               sx={{
    //                 display: "flex",
    //                 flexDirection: "column",
    //                 alignItems: "center",
    //                 width: "100%",
    //                 margin: "16px",
    //               }}
    //             >
    //               <CircularProgress />
    //             </Box>
    //           </TableCell>
    //         </TableRow>
    //       )}
    //     </TableBody>
    //   </Table>
    // </Paper>
  );
};

export default AssignTarget;
